import React, { useCallback, useEffect, useState } from "react";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import _debounce from "lodash/debounce";
import { useGlobalContext } from "../../context/GlobalContext";
import {
  getProductType,
  getBrandsFormsAndSize,
  getHouseHoldData,
} from "../../services/filterOptions/filter";
import handleError from "../../utils/handleError";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getFilterOptionsForCoaster } from "../../services/filterOptions/filter";
import { RadioButton } from "primereact/radiobutton";
import SegmentSection from "./compareByComponents/SegmentSection";
import ColumnLayout from "./compareByComponents/ColumnLayout";
import {
  APP_CONSTANT,
  ecoNaturalBrands,
  getAppConstantCategoryValue,
  getDefaultColumns,
  mainstreamBrands,
  SAVE_BRANDS,
  SAVE_FAVORITE_BRANDS,
  subNumCountingCapital,
  valueBrands,
} from "../../utils/constants";
import { toSentenceCase } from "../../utils/constants";

const CompareBy = ({
  loading,
  setLoading,
  setCompareBy,
  setCheckedCRCategories,
  setSelectedComparisonBy,
  setApply,
  apply,
  setIsCompareByClicked,
  isCompareByClicked,
  chooseComparison,
  setChooseComparison,
  tabActiveIndex,
  setProductType,
  productType,
}) => {
  const {
    deviceCode,
    category,
    product_id,
    mappedCategory,
    project_id,
    isDemoCategory,
    isCustomRecruitCategory,
  } = useGlobalContext();
  const { token, selectedClientName } = useSelector((state) => state.auth);
  const {
    brandsList,
    formsList,
    houseHoldlist,
    favoriteBrands,
    customRecruitCategories,
  } = useSelector((state) => state.dashboard);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const comparisonOptions = [
    {
      label: "Compare by Brand",
      value: "brand",
      searchLabel: "Brands",
      subTitle:
        "Select the products for each column and click Apply. To group brands, select multiple brands below. Click on the blue pencil and type in a name for the custom group and click Apply.",
    },
    {
      label: "Compare by Product Form",
      value: "form",
      searchLabel: "Product Forms",
      subTitle:
        "Select the variables for each column in your comparison and name your columns..",
    },
    {
      label: "Compare by Segment",
      value: "household",
      searchLabel: "Segments",
      subTitle: "Click to remove segments from your comparison",
    },
  ];

  const [comparisonOption, setComparisonOption] = useState([]);
  const [selectedSegment, setSelectedSegment] = useState("");
  const [segmentOptions, setSegmentOptions] = useState([]);
  const [showBrandNameValidation, setShowBrandNameValidation] = useState(false);

  const [columns, setColumns] = useState(
    getDefaultColumns(isCustomRecruitCategory),
  );

  useEffect(() => {
    const defaultColumns = getDefaultColumns(isCustomRecruitCategory);
    const resetData = defaultColumns.reduce((result, col, index) => {
      const key = `key_${index + 1}`;
      result[key] = {
        name:
          index === 0
            ? getAppConstantCategoryValue(isCustomRecruitCategory)
            : col.value,
        value:
          index === 0
            ? getAppConstantCategoryValue(isCustomRecruitCategory)
            : col.selectedComparisons.join("|") || "",
      };
      return result;
    }, {});

    setCompareBy(resetData);
    setCheckedCRCategories([]);
  }, []);

  const handleColumnChange = (index, newValue) => {
    setColumns((prevColumns) =>
      prevColumns.map((col, i) =>
        i === index ? { ...col, columnEditVal: newValue } : col,
      ),
    );
  };

  const handleCheckboxChange = (index, optionVal) => {
    const optionValue = optionVal.value;
    const optionLabel = optionVal.label;
    setColumns((prevColumns) =>
      prevColumns.map((col, i) => {
        if (i === index) {
          const updatedComparisons =
            index === 0 &&
            optionValue === getAppConstantCategoryValue(isCustomRecruitCategory)
              ? col.selectedComparisons
              : col.selectedComparisons.includes(optionValue)
                ? col.selectedComparisons.filter((val) => val !== optionValue)
                : [...col.selectedComparisons, optionValue];

          return {
            ...col,
            selectedComparisons: updatedComparisons,
            optionLabel: optionLabel,
          };
        }
        return col;
      }),
    );
  };

  const handleChooseComparison = (optionValue) => {
    setChooseComparison(optionValue);
    setSelectedComparisonBy(optionValue);
    const defaultColumns = getDefaultColumns(isCustomRecruitCategory);
    setColumns(defaultColumns);
    setComparisonOption([]);
    setSelectedSegment("");
    setSegmentOptions([]);

    // Reset resultData to match default columns
    const resetData = defaultColumns.reduce((result, col, index) => {
      const key = `key_${index + 1}`;
      result[key] = {
        name:
          index === 0
            ? getAppConstantCategoryValue(isCustomRecruitCategory)
            : col.value,
        value:
          index === 0
            ? getAppConstantCategoryValue(isCustomRecruitCategory)
            : col.selectedComparisons.join("|") || "",
      };
      return result;
    }, {});

    setCompareBy(resetData);
    setApply(!apply);
    setCheckedCRCategories([]);
  };

  const handleApply = () => {
    const resultData = columns.reduce((result, col, index) => {
      const key = `key_${index + 1}`;
      result[key] = {
        name:
          index === 0
            ? getAppConstantCategoryValue(isCustomRecruitCategory)
            : col.value.trim()
              ? col.value
              : isDemoCategory
                ? col?.optionLabel
                : col?.selectedComparisons?.length === 1
                  ? `${col?.selectedComparisons[0]}`
                  : "",
        value:
          index === 0
            ? getAppConstantCategoryValue(isCustomRecruitCategory)
            : col.selectedComparisons.join("|") || "",
      };
      return result;
    }, {});
    setCompareBy(resultData);
    if (isCustomRecruitCategory && customRecruitCategories?.length) {
      setCheckedCRCategories(columns[0]?.unCheckedCRCategories || []);
    }
    setApply(!apply);
    setIsCompareByClicked(true);
    setTimeout(() => {
      setIsCollapsed(true);
    }, 500);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleReset = () => {
    // setChooseComparison("");
    // Reset columns to default state
    // const defaultColumns = getDefaultColumns();
    // setColumns(defaultColumns);

    const defaultColumns = columns.map((col, index) => ({
      ...col,
      colComparisonOptions: comparisonOption,
      value: isDemoCategory ? addDemoGroupsData("value", index) : "",
      filterVal: "",
      selectedComparisons: isDemoCategory
        ? addDemoGroupsData("selectedComparisons", index)
        : index === 0
          ? [getAppConstantCategoryValue(isCustomRecruitCategory)]
          : [],
      isColumnEditMode: false,
      columnEditVal: "",
      // unCheckedCRCategories: [],
    }));

    setColumns(defaultColumns);

    // Reset resultData to match default columns
    const resetData = defaultColumns.reduce((result, col, index) => {
      const key = `key_${index + 1}`;
      result[key] = {
        name:
          index === 0
            ? getAppConstantCategoryValue(isCustomRecruitCategory)
            : col.value,
        value:
          index === 0
            ? getAppConstantCategoryValue(isCustomRecruitCategory)
            : col.selectedComparisons.join("|") || "",
      };
      return result;
    }, {});

    setCompareBy(resetData);
    // setCheckedCRCategories([]);
    setApply(!apply);
    setIsCompareByClicked(false);
    setIsCollapsed(false);
    // setProductType("");
    // setSelectedComparisonBy("");
    // setComparisonOption([]);
  };

  const getComparisonOptions = (chooseComparison, forms, brands) => {
    if (chooseComparison === "brand") {
      return brands.map((brand) => ({ value: brand, label: brand }));
    } else if (chooseComparison === "form") {
      return forms.map((form) => ({ value: form, label: form }));
    }
    return [];
  };

  const fetchBrandsForms = () => {
    // setLoading(true);
    // setColumns((prevColumns) =>
    //   prevColumns.map((col, index) => ({
    //     ...col,
    //     selectedComparisons: index === 0 ? [APP_CONSTANT.CATEGORY_VALUE] : [],
    //   })),
    // );
    // const requestBody = {
    //   product_id: parseInt(product_id),
    //   project_id: parseInt(project_id),
    // };
    // getProductType(requestBody, token)
    //   .then(async (response) => {
    //     if (response.status === 200 && chooseComparison !== null) {
    //       const request_body = {
    //         product_id: parseInt(product_id),
    //         product_type: deviceCode === 1 ? "product" : response.data.type,
    //         project_id: parseInt(project_id),
    //         mapped_category: mappedCategory
    //       };
    //       const [brandsFormsAndSizeResponse] = await Promise.all([
    //         getBrandsFormsAndSize(request_body, token),
    //       ]);
    //       setFormsList(brandsFormsAndSizeResponse.data.barcode_details.forms);
    //       setBrandsList(brandsFormsAndSizeResponse.data.barcode_details.brands);
    //       const comparisonOptionData = getComparisonOptions(
    //         chooseComparison,
    //         brandsFormsAndSizeResponse.data.barcode_details.forms,
    //         brandsFormsAndSizeResponse.data.barcode_details.brands,
    //       );
    //       setComparisonOption(comparisonOptionData);
    //       setColumns((prevColumns) =>
    //         prevColumns.map((col, index) => ({
    //           ...col,
    //           colComparisonOptions: comparisonOptionData
    //         })),
    //       );
    //     } else {
    //       setError("Failed to fetch product types. Unexpected status code.");
    //     }
    //   })
    //   .catch((error) => {
    //     handleError(error, navigate, dispatch);
    //   })
    //   .finally(() => {
    //     setLoading(false);
    //   });
  };

  const fetchFilterCompareOptionsForCoaster = async () => {
    try {
      setLoading(true);
      setColumns((prevColumns) =>
        prevColumns.map((col, index) => ({
          ...col,
          selectedComparisons:
            index === 0
              ? [getAppConstantCategoryValue(isCustomRecruitCategory)]
              : [],
        })),
      );

      const [brandsAndFormsResponse] = await Promise.all([
        getFilterOptionsForCoaster(
          project_id,
          category,
          chooseComparison,
          token,
        ),
      ]);

      const responseData = brandsAndFormsResponse?.data?.data || [];

      const comparisonOptionData = getComparisonOptions(
        chooseComparison,
        chooseComparison === "form" ? responseData : "",
        chooseComparison === "brand" ? responseData : "",
      );
      setComparisonOption(comparisonOptionData);
      setColumns((prevColumns) =>
        prevColumns.map((col, index) => ({
          ...col,
          colComparisonOptions: comparisonOptionData,
        })),
      );
    } catch (error) {
      console.error("Error fetching filter compare options:", error);
    } finally {
      setLoading(false);
    }
  };

  const getHouseHoldDataOptions = () => {
    getHouseHoldData(parseInt(project_id), token)
      .then((response) => {
        if (response.status === 200) {
          if (Object.entries(response?.data?.data).length > 0) {
            let householdData = Object.entries(response?.data?.data);
            householdData = householdData.map((data) => {
              return {
                heading: data[0].split(", ")[1],
                values: data[1].uniques.map((uniqVal) => uniqVal.uniques),
              };
            });
            setSegmentOptions(householdData);
          }
        }
      })
      .catch((error) => {
        handleError(error, navigate, dispatch);
      });
  };

  const addDemoGroupsData = (filedType, index) => {
    if (filedType === "value") {
      if (index === 1) {
        return "Value Brands";
      } else if (index === 2) {
        return "Mainstream Brands";
      } else if (index === 3) {
        return "Eco/Natural";
      } else {
        return "";
      }
    }

    if (filedType === "selectedComparisons") {
      if (index === 1) {
        return valueBrands;
      } else if (index === 2) {
        return mainstreamBrands;
      } else if (index === 3) {
        return ecoNaturalBrands;
      } else if (index === 1) {
        return [getAppConstantCategoryValue(isCustomRecruitCategory)];
      } else {
        return [];
      }
    }
  };

  useEffect(() => {
    if (chooseComparison) {
      // if(chooseComparison !== 'household') {
      //   if (deviceCode === 1) {
      //     fetchFilterCompareOptionsForCoaster();
      //   } else {
      //     fetchBrandsForms();
      //   }
      // } else {
      //   getHouseHoldDataOptions();
      // }
      if (chooseComparison === "brand") {
        const comparisonOptionData = brandsList.map((brand, i) => ({
          value: brand,
          label: isDemoCategory ? `Brand ${subNumCountingCapital[i]}` : brand,
        }));
        setComparisonOption(comparisonOptionData);
        setColumns((prevColumns) =>
          prevColumns.map((col, index) => ({
            ...col,
            selectedComparisons: isDemoCategory
              ? addDemoGroupsData("selectedComparisons", index)
              : isCustomRecruitCategory &&
                  favoriteBrands?.length > 0 &&
                  index === 1
                ? favoriteBrands?.some((val) => brandsList.includes(val))
                  ? [...favoriteBrands]
                  : []
                : [],
            value: isDemoCategory
              ? addDemoGroupsData("value", index)
              : isCustomRecruitCategory &&
                  favoriteBrands?.length > 0 &&
                  index === 1
                ? favoriteBrands?.length > 1
                  ? `${selectedClientName} Brands`
                  : ""
                : "",
            colComparisonOptions: comparisonOptionData,
          })),
        );
      } else if (chooseComparison === "form") {
        const comparisonOptionData = formsList.map((form) => ({
          value: form,
          label: form,
        }));
        setComparisonOption(comparisonOptionData);
        setColumns((prevColumns) =>
          prevColumns.map((col, index) => ({
            ...col,
            colComparisonOptions: comparisonOptionData,
          })),
        );
      } else {
        if (Object.entries(houseHoldlist).length > 0) {
          let householdData = Object.entries(houseHoldlist);
          householdData = householdData.map((data) => {
            return {
              heading: data[0].split(", ")[1],
              values: data[1].uniques.map((uniqVal) => uniqVal.uniques),
            };
          });
          setSegmentOptions(householdData);
          setComparisonOption([]);
          setColumns((prevColumns) =>
            prevColumns.map((col, index) => ({
              ...col,
              colComparisonOptions: [],
            })),
          );
        }
      }
    }
  }, [
    chooseComparison,
    product_id,
    brandsList,
    isDemoCategory,
    isCustomRecruitCategory,
  ]);

  useEffect(() => {
    setProductType("");
    handleReset();
  }, [isCustomRecruitCategory]);

  useEffect(() => {
    handleReset();
  }, [product_id, isDemoCategory]);

  useEffect(() => {
    const defaultColumnsData = getDefaultColumns(isCustomRecruitCategory);
    if (columns.length > 0) {
      columns.some((column, index) => {
        if (
          column.selectedComparisons.length > 1 &&
          defaultColumnsData[index]?.value === column.value
        ) {
          setShowBrandNameValidation(true);
          return true;
        }
        if (index === columns.length - 1) {
          setShowBrandNameValidation(false);
          return false;
        }
      });
    }
  }, [columns]);

  const processSelectComparisonOption = (col) => {
    if (col?.selectedComparisons && col?.selectedComparisons?.length) {
      const getSelectedItems = comparisonOption.filter((data) =>
        col?.selectedComparisons.includes(data.value),
      );
      const getUnSelectedItems = comparisonOption.filter(
        (data) => !col?.selectedComparisons.includes(data.value),
      );
      const combinedArr = [...getSelectedItems, ...getUnSelectedItems];
      return combinedArr;
    } else {
      return comparisonOption;
    }
  };

  const handleDebounceFn = (inputValue, index) => {
    setColumns((prevColumns) =>
      prevColumns.map((col, i) =>
        i === index
          ? {
              ...col,
              filterVal: inputValue,
              colComparisonOptions:
                inputValue !== ""
                  ? comparisonOption?.filter((item) =>
                      item.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase()),
                    )
                  : processSelectComparisonOption(col),
            }
          : col,
      ),
    );
  };

  const debounceFn = useCallback(_debounce(handleDebounceFn, 500), [
    comparisonOption,
  ]);

  const panelFooterTemplate = () => {
    return (
      <div className="panel-footer d-flex align-items-center p-3">
        <h6 className="text-uppercase mb-0">
          {
            comparisonOptions.find(
              (option) => option.value === chooseComparison,
            )?.label
          }
        </h6>
        {chooseComparison === "household" && selectedSegment ? (
          <>
            <h6 className="divider mb-0 px-3">|</h6>
            <h6 className="text-uppercase mb-0">{selectedSegment}</h6>
          </>
        ) : (
          ""
        )}
      </div>
    );
  };

  const handleUnCheckedCRCategories = async (unCheckValue) => {
    let updatedUCCategories = [];
    let unCheckedCRCategories = columns[0]?.unCheckedCRCategories;
    // check only single customRecruit category selected
    if (unCheckedCRCategories?.length === customRecruitCategories?.length - 1) {
      let checkedCatData = customRecruitCategories?.filter(
        (val) => !unCheckedCRCategories.some((cat) => cat.id === val.id),
      );
      if (checkedCatData[0].id === unCheckValue?.id) {
        return false;
      }
    }
    if (
      unCheckedCRCategories?.some(
        (crValues) => crValues?.id === unCheckValue?.id,
      )
    ) {
      updatedUCCategories = unCheckedCRCategories.filter(
        (values) => values?.id !== unCheckValue?.id,
      );
      setColumns((prevColumns) =>
        prevColumns.map((col, i) =>
          i === 0
            ? { ...col, unCheckedCRCategories: updatedUCCategories }
            : col,
        ),
      );
    } else {
      updatedUCCategories = [...unCheckedCRCategories, unCheckValue];

      setColumns((prevColumns) =>
        prevColumns.map((col, i) =>
          i === 0
            ? { ...col, unCheckedCRCategories: updatedUCCategories }
            : col,
        ),
      );
    }

    let checkedCategoriesData = customRecruitCategories?.filter(
      (val) => !updatedUCCategories.some((cat) => cat.id === val.id),
    );

    const request_body = {
      product_id: parseInt(product_id),
      product_type: productType,
      project_id: parseInt(project_id),
      mapped_category: mappedCategory,
      mapped_category_arr: checkedCategoriesData?.length
        ? checkedCategoriesData?.map((data) => data?.mapped_category)
        : [],
      product_id_arr: checkedCategoriesData?.length
        ? checkedCategoriesData?.map((data) => data?.id)
        : [],
    };

    setLoading(true);
    try {
      const brandsResponse = await getBrandsFormsAndSize(request_body, token);

      const favoriteBrands =
        brandsResponse?.data?.barcode_details?.favorite_brand || [];
      let brandsData = brandsResponse?.data?.barcode_details?.brands || [];

      // handle show favorite brands on top as selected items
      if (favoriteBrands && favoriteBrands?.length > 0) {
        let unSelectedBrands = brandsData?.filter(
          (brandData) => !favoriteBrands?.includes(brandData),
        );
        let selectedBrands = brandsData?.filter((brandData) =>
          favoriteBrands?.includes(brandData),
        );

        brandsData = [...selectedBrands, ...unSelectedBrands];
      }
      dispatch({
        type: SAVE_BRANDS,
        payload: brandsData,
      });

      dispatch({
        type: SAVE_FAVORITE_BRANDS,
        payload: favoriteBrands,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error, navigate, dispatch);
    }
  };

  return (
    <>
      <Panel
        id="compareBySection"
        className="mt-2 text-start"
        header={
          <p
            className="d-contents fs-5 mb-0 p-3"
            onClick={() => setIsCollapsed(!isCollapsed)}
            style={{ cursor: "pointer" }}
          >
            Compare By Brand
          </p>
        }
        toggleable
        collapsed={
          isCollapsed || (tabActiveIndex === 4 && isCustomRecruitCategory)
        }
        onToggle={(e) => setIsCollapsed(e.value)}
        expandIcon={<span className="pi pi-angle-up"></span>}
        collapseIcon={<span className="pi pi-angle-down"></span>}
        // onClick={() => setIsCollapsed(!isCollapsed)}
        // footerTemplate={
        //   isCollapsed && chooseComparison ? panelFooterTemplate : ""
        // }
        disabled={tabActiveIndex === 4 && isCustomRecruitCategory}
      >
        <div
          className="d-flex flex-column p-3"
          style={{ borderTop: "1px solid #dee2e6" }}
        >
          {/* commented later when we have other radio option need to show then it required. */}
          {/* <div className="mb-4 pb-2">
            <h6 className="fw-semibold">Step 1:</h6>
            <p
              className="mb-0 text-start fw-bold fs-12 pb-3"
              style={{ color: "#9E9E9E" }}
            >
              Choose your comparison type
            </p>
            <div className="d-flex flex-wrap gap-4">
              {comparisonOptions.map((option) => (
                <div
                  className="d-flex align-items-center justify-content-center"
                  key={option.value}
                >
                  <RadioButton
                    inputId={option.value}
                    name="comparison-value"
                    value={option.value}
                    onChange={(e) => handleChooseComparison(e.value)}
                    checked={chooseComparison === option.value}
                    disabled={loading && chooseComparison !== ""}
                  />
                  <label htmlFor={option.value} className="ms-2">
                    {option.label}
                  </label>
                </div>
              ))}
            </div>
          </div> */}

          <div>
            {/* <h6 className="fw-semibold">Step 2:</h6> */}
            <p
              className="mb-0 text-start fw-bold fs-14 pb-3"
              style={{ color: "#9E9E9E" }}
            >
              {
                comparisonOptions?.find(
                  (optionVal) => optionVal?.value === chooseComparison,
                )?.subTitle
              }
            </p>
            <div className="row">
              {chooseComparison === "household" ? (
                <>
                  <div className="col-3 col-md-2">
                    <div className="column-heading">
                      {toSentenceCase(`${category} Average`)}
                    </div>
                    <SegmentSection
                      segmentOptions={segmentOptions}
                      setSelectedSegment={(selectedVal) => {
                        setSelectedSegment(selectedVal);
                        let comparisonOptionData = segmentOptions.find(
                          (option) => option.heading === selectedVal,
                        );
                        comparisonOptionData =
                          comparisonOptionData?.values?.map((option) => {
                            return { label: option, value: option };
                          });
                        setComparisonOption(comparisonOptionData);
                        const segmentColSData = comparisonOptionData?.map(
                          (optionVal, i) => {
                            return {
                              value: optionVal.value,
                              selectedComparisons: [optionVal.value],
                              filterVal: "",
                              colComparisonOptions: comparisonOptionData,
                              isColumnEditMode: false,
                              columnEditVal: "",
                            };
                          },
                        );
                        // setColumns((prevColumns) =>
                        //   prevColumns.map((col, index) => ({
                        //     ...col,
                        //     colComparisonOptions: comparisonOptionData,
                        //     selectedComparisons: index === 0 ? [APP_CONSTANT.CATEGORY_VALUE] : []
                        //   })),
                        // );
                        setColumns([
                          {
                            value: "",
                            selectedComparisons: [
                              getAppConstantCategoryValue(
                                isCustomRecruitCategory,
                              ),
                            ],
                            filterVal: "",
                            colComparisonOptions: [],
                            isColumnEditMode: false,
                            columnEditVal: "",
                          },
                          ...segmentColSData,
                        ]);
                      }}
                      selectedSegment={selectedSegment}
                    />
                  </div>
                  <div className="col-9 col-md-10">
                    <div className="container my-4">
                      <div className="column-scroll-container">
                        {columns.map((column, index) =>
                          index === 0 ? (
                            ""
                          ) : (
                            <div
                              key={index}
                              className="col-3 col-md-2 column-cols px-2"
                            >
                              <ColumnLayout
                                column={column}
                                index={index}
                                chooseComparison={chooseComparison}
                                comparisonOption={comparisonOption}
                                loading={loading}
                                category={category}
                                comparisonOptions={comparisonOptions}
                                handleCheckboxChange={handleCheckboxChange}
                                setColumns={setColumns}
                                handleColumnChange={handleColumnChange}
                                debounceFn={debounceFn}
                                isDemoCategory={isDemoCategory}
                                isCustomRecruitCategory={
                                  isCustomRecruitCategory
                                }
                                customRecruitCategories={
                                  customRecruitCategories
                                }
                                handleUnCheckedCRCategories={
                                  handleUnCheckedCRCategories
                                }
                              />
                            </div>
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              {tabActiveIndex === 0 &&
                columns.slice(0, 2).map((column, index) => (
                  <div key={index} className="col-3 col-md-2">
                    <ColumnLayout
                      column={column}
                      index={index}
                      chooseComparison={chooseComparison}
                      comparisonOption={comparisonOption}
                      loading={loading}
                      category={category}
                      comparisonOptions={comparisonOptions}
                      handleCheckboxChange={handleCheckboxChange}
                      setColumns={setColumns}
                      handleColumnChange={handleColumnChange}
                      debounceFn={debounceFn}
                      showSearchFilter={true}
                      isDemoCategory={isDemoCategory}
                      isCustomRecruitCategory={isCustomRecruitCategory}
                      customRecruitCategories={customRecruitCategories}
                      handleUnCheckedCRCategories={handleUnCheckedCRCategories}
                    />
                  </div>
                ))}

              {chooseComparison !== "household" &&
                tabActiveIndex !== 0 &&
                columns.map((column, index) => (
                  <div key={index} className="col-3 col-md-2 column-cols">
                    <ColumnLayout
                      column={column}
                      index={index}
                      chooseComparison={chooseComparison}
                      comparisonOption={comparisonOption}
                      loading={loading}
                      category={category}
                      comparisonOptions={comparisonOptions}
                      handleCheckboxChange={handleCheckboxChange}
                      setColumns={setColumns}
                      handleColumnChange={handleColumnChange}
                      debounceFn={debounceFn}
                      isDemoCategory={isDemoCategory}
                      isCustomRecruitCategory={isCustomRecruitCategory}
                      customRecruitCategories={customRecruitCategories}
                      handleUnCheckedCRCategories={handleUnCheckedCRCategories}
                    />
                  </div>
                ))}
            </div>
          </div>

          <div className="d-flex align-items-center gap-2 managed-row">
            <Button
              label="Reset"
              className="p-button-text me-2 resetButton br-c fw-600"
              style={{ width: "100px", color: "gray" }}
              onClick={handleReset}
              disabled={chooseComparison === "" ? true : false}
            ></Button>
            <Button
              label="Apply"
              className="p-button-text me-2  active-button br-c fw-600"
              style={{ width: "100px" }}
              onClick={handleApply}
              disabled={
                chooseComparison === "" || showBrandNameValidation
                  ? true
                  : false
              }
            ></Button>

            {showBrandNameValidation ? (
              <div
                className="brand-name-validation ms-3 py-1 px-2"
                style={{
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  borderRadius: "4px",
                  fontWeight: "600",
                }}
              >
                <span className="pi pi-exclamation-triangle"></span> Please name
                your columns to populate charts
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </Panel>
    </>
  );
};

export default CompareBy;
